module.exports = __webpack_public_path__ + "media/images/giphy_attribution-9748c37d.png";